import ManageChirurgie from '@/views/parametres/configs/param-chirurgies/manage-chirurgie'
import ExcelModal from '@/views/parametres/import-excel-modal'
import $ from 'jquery'
import listesPaginees from '@/api/parametres/_listes-paginees'
import { nouvelleListe, chargerPage, rechercherDiffere } from '@/utils/liste-paginee'

export default {
    name: 'param-chirurgies',
    components: {
        ManageChirurgie, ExcelModal
    },
    props: [],
    data() {
        return {
            is_loading: true,
            is_empty: false,

            fields: [
				{ key: 'chirurgie', label: 'Libellé' }, { key: 'k_chirurgie', label: 'K-Chirurgie' }, 
                { key: 'actions', label: 'Action.s' }
			],
            // Page courante (pagination et recherche côté serveur, données locales au composant)
            chirurgies: nouvelleListe(),

            is_edit: false,

            save_loading: false,
            modal_title: 'Nouvelle chirurgie',
            exist_error: false,

            to_be_deleted: {
				id: 0,
				libelle: ''
			},
			is_confirm: false,
			del_loading: false,

            chirurgie_to_edit: {},

            is_printing: false,
            filename: '',

            modal_toggler: true,

            type_admission: '',
            designation: '',
            emit_action: '',

            chirurgie_fields: {
                'Chirurgie': 'chirurgie',
                'K-Chirurgie': 'k_chirurgie',
                'Prix': 'prix',
            },

            chirurgie_filename: 'Liste_Chirurgies.xls',

            c_loading_percentage: 0,
            can_view_percentage: false,
            c_refresh_timeout_id: null,
            countdown_seconds_left: 0,
            countdown_interval_id: null,
        }
    },

    beforeDestroy() {
        if (this.c_refresh_timeout_id) {
            clearTimeout(this.c_refresh_timeout_id)
            this.c_refresh_timeout_id = null
        }

        if (this.countdown_interval_id) {
            clearInterval(this.countdown_interval_id)
            this.countdown_interval_id = null
        }
    },

    mounted() {
        this.getListeChirurgies()

        var d = new Date()
        var tmpstamp = d.getHours()+''+d.getMinutes()+''+d.getFullYear()

        this.filename = 'Liste_chirurgies_'+tmpstamp
    },

    methods: {
        /**
         * Recherche côté serveur après la saisie (retour à la page 1)
         */
        rechercher(liste, charger) {
            rechercherDiffere(liste, charger)
        },

        addPrestation() {
            this.modal_title = 'Nouvelle chirurgie'
            this.modal_toggler = (this.modal_toggler)?false:true
        },

        countdownLoad() {
            const TOTAL_SECONDS = 12 * 60

            if (this.countdown_interval_id) {
                clearInterval(this.countdown_interval_id)
                this.countdown_interval_id = null
            }

            this.countdown_seconds_left = TOTAL_SECONDS
            // Initialize percentage based on full remaining time
            this.c_loading_percentage = 100

            this.countdown_interval_id = setInterval(() => {
                if (this.countdown_seconds_left > 0) {
                    this.countdown_seconds_left--
                    // Update loading percentage according to remaining time
                    this.c_loading_percentage = (this.countdown_seconds_left / TOTAL_SECONDS) * 100
                } else {
                    clearInterval(this.countdown_interval_id)
                    this.countdown_interval_id = null
                    this.c_loading_percentage = 0
                }
            }, 1000)
        },

		refreshListeChirurgues() {
            this.is_loading = true
            this.can_view_percentage = true
            if (this.c_refresh_timeout_id) {
                clearTimeout(this.c_refresh_timeout_id)
                this.c_refresh_timeout_id = null
            }

            if (this.chirurgies.total > 0) {
                this.countdown_seconds_left = 0
            }

            if (this.countdown_seconds_left == 0 ) {
                this.can_view_percentage = false
                this.getListeChirurgies()
                return
            }

            // Re-fetch then retry after 5s until counts match
            this.getListeChirurgies()
            this.c_refresh_timeout_id = setTimeout(() => {
                this.refreshListeChirurgues()
            }, 5000)
        },

		loadEmitAction() {
            this.countdownLoad()
            this.refreshListeChirurgues()
        },

        /**
         * Recharge la page courante (après ajout, modification, suppression, import)
         */
        getListeChirurgies() {
            return chargerPage(this.chirurgies, params => listesPaginees.chirurgies(params)).then(() => {
                if (this.chirurgies.chargement) {
                    // Réponse périmée : une requête plus récente est en cours
                    return
                }

                // Catalogue vide (hors recherche) : message « Aucune donnée disponible »
                this.is_empty = !this.chirurgies.erreur && this.chirurgies.total == 0 && this.chirurgies.q == ''

                if (this.can_view_percentage) {
                    if (this.countdown_seconds_left == 0) {
                        this.is_loading = false
                    }
                } else {
                    this.is_loading = false
                }
            })
        },

        edit(chirurgie) {
            this.modal_title = 'Modifier'
            this.chirurgie_to_edit = chirurgie
            this.modal_toggler = (this.modal_toggler)?false:true
        },

        setToDelete(c) {
            this.to_be_deleted = {
                id: c.chirurgie_id,
                chirurgie: c.chirurgie
            }
        },

         /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimer(selector) {
            this.del_loading = true;

            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }

            this.$store.dispatch('deleteItem', this.to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast("Chirurgie supprimée avec succès")
                    this.getListeChirurgies()

                    this.is_confirm = false
                    this.$refs.chirurgieDelModal.click();
                }
                this.del_loading = false
            }).catch((err) => {
                console.log("ERROR CATCH: ", err)
                this.del_loading = false
            })
        },

        handleBeforeGenerateChirurgie() {
            let d = new Date()
            this.chirurgie_filename = 'Liste_Chirurgies_'+d.getMilliseconds()+'.xls'
            this.is_exporting = true
        },

        importExcelFile(type_admission, designation) {
            this.type_admission = type_admission
            this.designation = designation
            this.modal_toggler = (this.modal_toggler)?false:true

            this.emit_action = 'emitChirurgie'

            setTimeout(() => {
                $('.excel-modal-'+type_admission).modal('show')
            }, 200);  
        },

        /**
         * Export Excel : la liste complète est chargée au clic
         * (prop `fetch` de export-excel, appelée après before-generate)
         */
        fetchExportChirurgies() {
            return listesPaginees.chirurgies().then((chirurgies) => {
                const lignes = []
                const liste = chirurgies || []
                liste.forEach(chirurgie => {
                    (chirurgie.kchirurgies || []).forEach(kchirurgie => {
                        lignes.push({
                            'chirurgie': chirurgie.chirurgie,
                            'k_chirurgie' : kchirurgie.k_chirurgie,
                            'prix' : (kchirurgie.pu > 0)?kchirurgie.pu:''
                        })
                    });
                });

                if (lignes.length == 0) {
                    // Rien à exporter : export-excel s'arrête sans appeler before-finish
                    this.is_exporting = false
                }
                return lignes
            }).catch(() => {
                this.is_exporting = false
                this.errorToast("Impossible de préparer l'export. Merci de réessayer.")
                return []
            })
        },

        printChirurgie() {
            if (this.is_printing) {
                return
            }
            this.is_printing = true

            // Impression de la liste complète, chargée au clic
            listesPaginees.chirurgies().then((chirurgies) => {
                const data = {
                    data_type: 'chirurgies',
                    prestations: chirurgies || []
                }
                this.$emit('emitTriggerPrint', data)
            }).catch(() => {
                this.errorToast("Impossible de charger la liste à imprimer. Merci de réessayer.")
            }).finally(() => {
                this.is_printing = false
            })
        }
    }
}